export const getVariantData = (activeVariant?: string): VariantData | null => {
  switch (activeVariant) {
    case 'A-ExperimentA':
      return { exp_a: true, exp_b: false };
    case 'B-ExperimentB':
      return { exp_a: false, exp_b: true };
    case 'C-Control':
      return { exp_a: false, exp_b: false };
    default:
      return null;
  }
};

export const isVariant = (variant: string, activeVariant?: string): boolean => {
  return activeVariant?.startsWith(`${variant}-`) ?? false;
};
